import { __assign } from 'tslib';
import React__default from 'react';
import { Typography } from '@mui/material';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

var NoResultFilterFolder = function (_a) {
    var _b = _a.testId, testId = _b === void 0 ? "NoResultFilterFolder" : _b, className = _a.className, _c = _a.id, id = _c === void 0 ? "NoResultFilterFolder" : _c, style = _a.style, sx = _a.sx;
    var t = useTranslation("refront-components").t;
    return (React__default.createElement(Typography, { className: clsx("NoResultFilterFolder", className), "data-testid": testId, id: id, style: style, sx: __assign({ padding: function (theme) { return theme.spacing(0, 1, 1, 1); }, fontSize: "0.875rem", fontStyle: "italic", color: function (theme) { return theme.palette.grey[500]; }, cursor: "default" }, sx) }, t("filter.folder.no.subfolders")));
};

export { NoResultFilterFolder as default };
//# sourceMappingURL=index.js.map
